/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import DumbbellIcon from "../Image/dumbbell.png";

const GymProgramCard = ({ title, desc }) => (
  <div css={styles} className="card">
    <img src={DumbbellIcon} alt="dumbbell" />
    <div className="cardInfo">
      <h2>{title}</h2>
      <p>{desc}</p>
    </div>
  </div>
);

const styles = css`
  width: 100%;
  max-width: 37%;
  display: flex;
  text-align: left;
  margin:8px 0;
  background-color:#ffffb3;
  border-radius:8px;
  img {
    margin-right: 30px;
  }
  .cardInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h2 {
      color: red;
      padding:10px 0px 0px 10px;
    }
    p {
      color: green;
      font-size: 14px;
      line-height: 1.7;
      padding:10px 20px 10px 10px;
    }
    }
  }
  @media (max-width: 700px) {
    max-width: 100%;
  }
  @media (min-width: 701px) and (max-width: 1100px){
    max-width: 80%;
  }
`;

export default GymProgramCard;
